<template>
  <div class="wx-mask" v-show="maskShow" @touchmove.prevent>
    <div class="wx-box">
    <div class="wx-tips-r">
        <img src="../assets/images/20181212/arrow@3x.png" class="icon-wx-arrow">
    </div>
    <div class="wx-tips-l">
        <div class="wx-tips-l-item">
        <img src="../assets/images/20181212/icon_one.png" class="icon-wx icon-num"><span style="white-space: nowrap">{{ $t('click') }}</span><img src="../assets/images/20181212/select@3x.png" class="icon-wx icon-tip-item"><span>{{ $t('wx-tip1') }}</span>
        </div>
        <div class="wx-tips-l-item">
        <img src="../assets/images/20181212/icon_two.png" class="icon-wx icon-num"><span style="white-space: nowrap">{{ $t('select') }}</span><img src="../assets/images/20181212/Browser@3x.png" class="icon-wx icon-tip-item"><span>{{ $t('wx-tip2') }}</span>
        </div>
    </div>
    </div>
</div>
</template>

<script>
export default {
  props: {
    maskShow: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
    .wx-mask{
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
    }

    .wx-box{
      overflow: hidden;
      float: right;
      width: 100%;
    }

    .wx-tips-l, .wx-tips-r{
      float: right;
    }
    .wx-tips-r{
      min-width: 0.404rem;
    }
    .wx-tips-l{
      font-family: PingFangSC-Regular;
      font-size: 0.15rem;
      color: #FFFFFF;
      line-height: 0.18rem;
      text-align: left;
      padding-left: 0.02rem;
      max-width: 2.8rem;
    }

    .wx-tips-l-item{
      display: flex
    }

    .wx-tips-l div{
      overflow: hidden;
    }

    .wx-tips-l div:first-child{
      margin-top: 0.34rem;
    }

    .wx-tips-l div:not(:first-child){
      margin-top: 0.18rem;
    }

    .wx-tips-l img, .wx-tips-l span{
      display: inline-block;
      vertical-align: middle;
    }

    .icon-wx-arrow{
      width: 0.404rem;
      height: 0.5645rem;
      margin: 0.075rem 0.207rem 0 0.074rem;
    }
    .icon-wx{
      width: 0.18rem;
      height: 0.18rem;
    }

    .icon-num{
      margin-right: 0.05rem;
    }

    .icon-tip-item{
      margin: 0 0.03rem;
    }
</style>



// WEBPACK FOOTER //
// WxMask.vue?50715111